import React, { FC, memo, useEffect, useState } from 'react';
import { Button, Input, message, Modal, Radio } from 'udesk-ui';
// import styled from 'styled-components';
import { useRequest } from 'ahooks';
import { RadioChangeEvent } from 'antd';
import { LanguageEnum } from 'Component/pages/components/LanguageSelect/const';
import _map from 'lodash-es/map';
import isNil from 'lodash/isNil';
import { getInspectionModulesByTypeDataSourceByDataSource } from 'src/api/inspectionModules/{type}/dataSource/{dataSource}';
import { getInspectionPointTemplates } from 'src/api/inspectionPointTemplates';
import { getPointTemplatePointsMyByInspectDataSource } from 'src/api/pointTemplate/points/my/{inspectDataSource}';
import UdeskLocales from 'UdeskLocales';
import './style.scss';

type TemplateProps = {
    visible?: boolean;
    onCancel?: (loadData?: boolean) => void;
    onTemplateClick?: (item: any, templateValue: string) => void;
    onSaveInspectionRule?: (ruleDescription: string) => void;
    dataSource?: number;
    showCustomRuleTemplate?: boolean;
    lang?: number;
};

const Template: FC<TemplateProps> = memo((props) => {
    const {
        visible,
        onCancel,
        onTemplateClick,
        onSaveInspectionRule,
        dataSource,
        showCustomRuleTemplate,
        lang,
    } = props;
    const [templateValue, setTemplateValue] = useState('a');
    const [templateList, setTemplateList] = useState<any[]>([]);
    const [checkData, setCheckData] = useState<any[]>([]);
    const [checkModuleData, setCheckModuleData] = useState<any[]>([]);
    const [customRuleTemplate, setCustomRuleTemplate] = useState<any[]>([]);
    const [ruleDescription, setRuleDescription] = useState('');
    const [isGenerating, setIsGenerating] = useState(false);
    useRequest(() => getInspectionPointTemplates({ params: { dataSource: dataSource! } }), {
        ready: !!dataSource,
        refreshDeps: [dataSource],
        onSuccess: (res) => {
            const data = [
                {
                    name: UdeskLocales['current'].pages.tasks.manage.template.checkPoint.index
                        .customize,
                },
                ...(res.data || []),
            ];

            setCheckData(data);
            setTemplateList(data);
            setTemplateValue('a');
        },
    });

    useRequest(
        () => {
            return getInspectionModulesByTypeDataSourceByDataSource({
                segments: { dataSource: dataSource!, type: 2 },
                params: {
                    langList: !isNil(lang)
                        ? lang === LanguageEnum.All
                            ? [LanguageEnum.All]
                            : [LanguageEnum.All, lang]
                        : undefined,
                },
            });
        },
        {
            ready: !!dataSource,
            onSuccess: (res) => {
                let checkModuleData = [];
                _map(res.data || {}, (item, key) => {
                    checkModuleData = checkModuleData.concat(item);
                });
                setCheckModuleData(checkModuleData);
            },
        }
    );

    useRequest(
        () => {
            return getPointTemplatePointsMyByInspectDataSource({
                segments: { inspectDataSource: dataSource! },
                params: {
                    langList: !isNil(lang)
                        ? lang === LanguageEnum.All
                            ? [LanguageEnum.All]
                            : [LanguageEnum.All, lang]
                        : undefined,
                },
            });
        },
        {
            ready: !!dataSource,
            onSuccess: (res) => {
                setCustomRuleTemplate(res.data || []);
            },
        }
    );

    // 修改生成规则的函数
    const handleGenerateRule = async () => {
        if (!ruleDescription.trim()) {
            message.warning(/* 请输入规则描述 */UdeskLocales['current'].pages.tasks.manage.template.checkPoint.components.createModal.index.pleaseEnterARuleDescription);
            return;
        }

        setIsGenerating(true);
        try {
            await onSaveInspectionRule?.(ruleDescription);
            message.success(/* 规则生成成功 */UdeskLocales['current'].pages.tasks.manage.template.checkPoint.components.createModal.index.ruleGeneratedSuccessfully);
            setRuleDescription('');
        } catch (error) {
            console.error(/* 生成规则失败: */UdeskLocales['current'].pages.tasks.manage.template.checkPoint.components.createModal.index.failedToGenerateRule, error);
        } finally {
            setIsGenerating(false);
        }
    };

    const onRadioChange = (e: RadioChangeEvent) => {
        setRuleDescription('');
        setTemplateValue(e.target.value);
        if (e.target.value === 'a') {
            setTemplateList(checkData);
        } else if (e.target.value === 'b') {
            setTemplateList(checkModuleData);
        } else if (e.target.value === 'c') {
            setTemplateList(customRuleTemplate);
        } else if (e.target.value === 'd') {
            // AI 生成 tab
            setTemplateList([]); // 清空模板列表
        }
    };

    useEffect(() => {
        setRuleDescription('');
        setTemplateValue('a');
        setTemplateList(checkData);
    }, [checkData, visible]);

    return (
        <Modal
            visible={visible}
            title={UdeskLocales['current'].pages.tasks.manage.template.checkPoint.index.template}
            onCancel={() => onCancel?.()}
            footer={null}
            width={768}
            wrapClassName="check-point-index-create-modal"
        >
            <div className="check-point-index-create-modal-body">
                <div className="check-point-index-create-modal-tabs">
                    <Radio.Group
                        defaultValue="a"
                        buttonStyle="solid"
                        onChange={onRadioChange}
                        value={templateValue}
                    >
                        <Radio.Button value="a">
                            {
                                UdeskLocales['current'].pages.tasks.manage.template.checkPoint.index
                                    .tabs.template
                            }
                        </Radio.Button>

                        {showCustomRuleTemplate ? (
                            <Radio.Button value="c">
                                {/* 我的规则 */}
                                {
                                    UdeskLocales['current'].pages.tasks.manage.template.checkPoint
                                        .components.createModal.index.myRules
                                }
                            </Radio.Button>
                        ) : null}

                        <Radio.Button value="b">
                            {
                                UdeskLocales['current'].pages.tasks.manage.template.checkPoint.index
                                    .tabs.demo
                            }
                        </Radio.Button>
                        <Radio.Button value="d">{/* AI 生成 */}{UdeskLocales['current'].pages.tasks.manage.template.checkPoint.components.createModal.index.aIGeneration}</Radio.Button>
                    </Radio.Group>
                </div>

                {/* AI 生成表单 */}
                {templateValue === 'd' ? (
                    <div className="check-point-index-create-modal-ai">
                        <Input.TextArea
                            placeholder={/* 请输入规则描述，内容由AI生成, 仅供参考。 */UdeskLocales['current'].pages.tasks.manage.template.checkPoint.components.createModal.index.pleaseEnterTheRuleDescriptionTheContentIsGeneratedByAIForReferenceOnly}
                            value={ruleDescription}
                            onChange={(e) => setRuleDescription(e.target.value)}
                            rows={4}
                            style={{ marginBottom: 16 }}
                        />
                        <Button
                            type="primary"
                            onClick={handleGenerateRule}
                            loading={isGenerating}
                            style={{ marginBottom: 16 }}
                        >{/* 生成规则 */}{UdeskLocales['current'].pages.tasks.manage.template.checkPoint.components.createModal.index.generateRules}</Button>
                    </div>
                ) : (
                    <div className="check-point-index-create-modal-templates">
                        {templateList?.map((item, index) => {
                            return (
                                <div
                                    key={item.id}
                                    onClick={() => onTemplateClick?.(item, templateValue)}
                                    className="check-point-index-create-modal-templates-item"
                                >
                                    <div
                                        style={{
                                            textAlign: 'center',
                                        }}
                                    >
                                        <span className="udesk-qa-react-web-iconfont">
                                            {item.isAIGenerated ? '\ue6ce' : '\ue6cd'}
                                        </span>
                                    </div>
                                    <div className="check-point-index-create-modal-templates-item-name">
                                        {item.name}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </Modal>
    );
});

export default Template;
